import { connect } from "react-redux";
import CreditCardMarketingBanner from "app/pages/Booking/Payment/CreditCardMarketingBanner/CreditCardMarketingBanner";

const mapStateToProps = state => {
	return {
		brand: state.brand.code,
		resolution: state.resolution,
		shop: state.shop,
	};
};

export default connect(mapStateToProps)(CreditCardMarketingBanner);
